<div class="title w-100">
  <h6><b>{{ 'envelope.main-envelope.asideLeft.custom-Fields.positioning.title' | translate }}</b></h6>
</div>

<div left class="aside-left">
  <div class="form-horizontal">
    <div class="auto-section">
      <h5>{{ 'envelope.main-envelope.asideLeft.custom-Fields.positioning.automatic' | translate }}</h5>
      <span class="description-text" [innerHTML]="'envelope.main-envelope.asideLeft.custom-Fields.positioning.automaticDescription' | translate">
      </span>

      <div class="toggle-row">
        <cdx-toggle-switch
          [disabled]="!newEnvelopeService.editMode || newEnvelopeService.toggleDisabled"
          [toggledOn]="newEnvelopeService.includeSignature"
          (toggle)="onChangeIncludeSignature($event)">
        </cdx-toggle-switch>
        <cdx-label style="margin-left: 10px;" [options]="{label: 'envelope.main-envelope.asideRight.loadSignatures'}"></cdx-label>
      </div>

      <div *ngIf="interactService.withRubrics" class="toggle-row">
        <cdx-toggle-switch
          [toggledOn]="newEnvelopeService.includeRubrics"
          (toggle)="onChangeIncludeRubric($event)"
          (click)="handleToggleClickRubric($event)">
        </cdx-toggle-switch>
        <div class="toggle-label-group">
          <cdx-label style="margin-left: 10px;" [options]="{label: 'envelope.main-envelope.asideRight.loadRubrics', tooltipMessage: 'envelope.main-envelope.asideRight.tooltip.loadRubrics'}"></cdx-label>
        </div>
      </div>
    </div>

    <div class="manual-section">
      <h5>{{ 'envelope.main-envelope.asideLeft.custom-Fields.positioning.manual' | translate }}</h5>
      <span class="description-text">
        {{ 'envelope.main-envelope.asideLeft.custom-Fields.positioning.manualDescription' | translate }}
      </span>

      <div class="form-group mb-2 ml-1 mr-1">
        <cdx-custom-dropdown
          *ngIf="renderDropdown"
          [options]="signatoryCustomDropdown"
          (onSelectItem)="onSelectDropdownItem($event)">
        </cdx-custom-dropdown>
      </div>

      <div class="form-group mt-0 primary cdx-button__text mb-2">
        <div [className]="'drag-signature-button ' + (signatorySelected ? classComponent : 'drag-drop disabled')"
            style="border: 1px dashed; cursor: grab;">
          <fa-icon class="fa-lg mr-1" [icon]="['fas', 'signature']"></fa-icon>
          {{ 'envelope.main-envelope.asideLeft.custom-Fields.components.signatures' | translate }}
        </div>
      </div>

      <div class="form-group mt-0 primary cdx-button__text mb-2" *ngIf="interactService.withRubrics">
        <div [className]="'drag-rubric-button ' + ((signatorySelected && interactService.withRubrics) ? classComponent : 'drag-drop disabled')"
            style="border: 1px dashed; cursor: grab;">
          <fa-icon class="fa-lg mr-1" [icon]="['fas', 'signature']"></fa-icon>
          {{ 'envelope.main-envelope.asideLeft.custom-Fields.components.rubric' | translate }}
        </div>
      </div>
    </div>

    <div class="w-100 form-section" *ngIf="newEnvelopeService.includeComponent">
      <h5>{{ 'envelope.main-envelope.asideLeft.custom-Fields.form.title' | translate }}</h5>
      <span class="description-text">
        {{ 'envelope.main-envelope.asideLeft.custom-Fields.form.description' | translate }}
      </span>
      <ng-container>
        <div class="form-group mt-0 primary cdx-button__text mb-2">
          <div
            class="drag-custom-field-button drag-drop"
            [attr.data-custom-field-type]="CustomFieldTypeEnum.TextField"
            style="border: 1px dashed;">
            <fa-icon class="fa-lg mr-1" [icon]="['fas', 'text']"></fa-icon>
            {{ 'envelope.main-envelope.asideLeft.custom-Fields.components.textComponent' | translate }}
          </div>
        </div>

        <div class="form-group mt-0 primary cdx-button__text mb-2">
          <div class="drag-custom-field-button drag-drop"
            [attr.data-custom-field-type]="CustomFieldTypeEnum.CheckboxField" style="border: 1px dashed">
            <fa-icon class="fa-lg mr-1" [icon]="['far', 'check-square']"></fa-icon>
            {{ 'envelope.main-envelope.asideLeft.custom-Fields.components.checkboxComponent' | translate }}
          </div>
        </div>
      </ng-container>
    </div>

    <div class="btnRestoreDocument w-100">
      <div class="w-100 cdx-button__text" style="display: flex;">
        <button class="cdx-button cdx-button--secondary cdx-button--outline cdx-button--danger pb-2 mb-3"
          (click)="restoreDocument()">
          <span class="cdx-button__text">{{ 'envelope.main-envelope.asideLeft.custom-Fields.components.restoreDocument' |
            translate }}</span>
        </button>
      </div>
    </div>
  </div>
</div>